import VueRouter, { RouteConfig } from 'vue-router'

import authGuard from './auth.guard'
import {
  ROOM_ROUTE_NAME,
  ROOM_SETTINGS_ROUTE_NAME,
  ROOM_CUSTOMIZATION_ROUTE_NAME,
} from './router.constants'

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomePage/HomePage.vue'),
  },
  {
    path: '/activity',
    name: 'activities',
    component: () => import('@/views/ActivitiesPage/ActivitiesPage.vue'),
  },
  {
    path: '/activity/:id',
    name: 'activity',
    component: () => import('@/views/ActivityPage/ActivityPage.vue'),
    props: (route) => {
      return {
        id: parseInt(route.params.id),
      }
    },
  },
  {
    path: '/group',
    name: 'groups',
    component: () =>
      import('@/views/ActivityGroupsPage/ActivityGroupsPage.vue'),
  },
  {
    path: '/group/:id',
    component: () => import('@/views/ActivityGroupPage/ActivityGroupPage.vue'),
    props: (route) => {
      return {
        id: parseInt(route.params.id),
      }
    },
    children: [
      {
        path: '',
        name: 'group',
        component: () =>
          import('@/views/ActivityGroupPage/ActivityGroupPageActivities.vue'),
      },
      {
        path: 'settings',
        name: 'group.settings',
        component: () =>
          import(
            '@/views/ActivityGroupPage/ActivityGroupPageSettings/ActivityGroupPageSettings.vue'
          ),
      },
      {
        path: 'rooms',
        name: 'group.rooms',
        component: () =>
          import(
            '@/views/ActivityGroupPage/ActivityGroupPageRooms/ActivityGroupPageRooms.vue'
          ),
      },
    ],
  },
  {
    path: '/room/:id',
    component: () => import('@/views/RoomPage/RoomPage.vue'),
    props: (route) => {
      return {
        id: parseInt(route.params.id),
      }
    },
    children: [
      {
        path: '',
        name: ROOM_ROUTE_NAME,
        component: () => import('@/views/RoomPage/RoomPageActivities.vue'),
      },
      {
        path: 'settings',
        name: ROOM_SETTINGS_ROUTE_NAME,
        component: () =>
          import('@/views/RoomPage/RoomPageSettings/RoomPageSettings.vue'),
      },
      {
        path: 'customization',
        name: ROOM_CUSTOMIZATION_ROUTE_NAME,
        component: () =>
          import(
            '@/views/RoomPage/RoomPageCustomization/RoomPageCustomization.vue'
          ),
      },
    ],
  },
  {
    path: '/media',
    name: 'media',
    component: () => import('@/views/MediaPage/MediaPage.vue'),
  },
  {
    path: '/media-group/:id',
    name: 'media-group',
    component: () => import('@/views/MediaGroupPage/MediaGroupPage.vue'),
    props: (route) => {
      return {
        id: parseInt(route.params.id),
      }
    },
  },
  {
    path: '/media-groups',
    name: 'media-groups',
    component: () => import('@/views/MediaGroupsPage/MediaGroupsPage.vue'),
  },

  {
    path: '/rooms/:status',
    name: 'rooms',
    component: () => import('@/views/RoomsPage/RoomsPage.vue'),
    props: true,
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/SettingsPage.vue'),
  },
  {
    path: '/import',
    name: 'import',
    component: () => import('@/views/Import/ImportPage.vue'),
    props: (route) => {
      return {
        id: +route.query.id,
        game: route.query.game,
        session: route.query.session,
        url: route.query.url,
      }
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(authGuard)

export default router
